export default "__VITE_ASSET__C7Dw782M__"